import dhuppiConfig from "@/constant/config/clients/tempula/rooms/dhuppiConfig"
import neoraConfig  from "@/constant/config/clients/tempula/rooms/neoraConfig"
import murtiConfig  from "@/constant/config/clients/tempula/rooms/murtiConfig"
import paiyuuConfig from "@/constant/config/clients/tempula/rooms/paiyuuConfig"
import gurasConfig  from "@/constant/config/clients/tempula/rooms/gurasConfig"

export const ROOM_MAP = {
  dhuppi: { config: dhuppiConfig, catalogueId: "tempula-dh-001" },
  neora:  { config: neoraConfig,  catalogueId: "tempula-ne-001" },
  murti:  { config: murtiConfig,  catalogueId: "tempula-mu-001" },
  paiyuu: { config: paiyuuConfig, catalogueId: "tempula-pa-001" },
  guras:  { config: gurasConfig,  catalogueId: "tempula-gu-001" },
} as const

export type RoomSlug = keyof typeof ROOM_MAP
